// src/core/api/profileApi.js
import { axiosClient } from "./axiosClient";

// Existing (confirmed in your DashboardLayout usage)
const ME_URL = "/users/me/";

// Recommended (change if your backend uses a different URL)
const CHANGE_PASSWORD_URL = "/users/change-password/";

export const profileApi = {
  // GET /api/users/me/
  getMe() {
    return axiosClient.get(ME_URL);
  },

  // PATCH /api/users/me/
  updateMe(payload) {
    return axiosClient.patch(ME_URL, payload);
  },

  // POST /api/users/change-password/
  // If backend doesn't have this endpoint, either:
  // - change CHANGE_PASSWORD_URL, OR
  // - remove/hide password UI
  changePassword(payload) {
    return axiosClient.post(CHANGE_PASSWORD_URL, payload);
  },
};
